import _ from 'lodash';
import { makeAutoObservable, runInAction } from 'mobx';

export type NotificationBarItem = {
    id: string;
    title?: string;
    text: string;
    duration?: number; // 밀리초 단위 (기본값: 5000ms)
    visible: boolean;
    onClick?: () => void | Promise<void>;
};

class NotificationBarStore {
    items: NotificationBarItem[] = [];

    constructor() {
        makeAutoObservable(this);

        /* 테스트
        setTimeout(() => {
            this.show({
                title: '알림 바 테스트',
                text: '내용 내용',
                onClick: () => {
                    alert('clicked');
                },
            });
        }, 2000);
        */
    }

    /**
     * 알림 바 표시
     */
    show({
        title,
        text,
        duration = 5000,
        onClick,
    }: {
        title?: string;
        text: string;
        duration?: number;
        onClick?: () => void | Promise<void>;
    }): string {
        const id = _.uniqueId('notification_bar_');

        const item: NotificationBarItem = {
            id,
            title,
            text,
            duration,
            visible: false,
            onClick,
        };

        this.items.push(item);

        // 애니메이션을 위해 잠시 대기 후 표시
        setTimeout(() => {
            runInAction(() => {
                item.visible = true;
                // 배열 재할당으로 렌더링 강제
                this.items = _.map(this.items, (i) => {
                    if (i.id === id) {
                        return { ...i, visible: true };
                    }
                    return i;
                });
            });
        }, 100);

        // 자동으로 사라지도록 타이머 설정
        if (duration > 0) {
            setTimeout(() => {
                this.hide(id);
            }, duration);
        }

        return id;
    }

    /**
     * 알림 바 클릭 처리
     */
    async handleClick(id: string) {
        const item = this.items.find((i) => i.id === id);
        if (item?.onClick) {
            await item.onClick();
            this.hide(id);
        }
    }

    /**
     * 알림 바 숨기기
     */
    hide(id: string) {
        const item = this.items.find((i) => i.id === id);
        if (item) {
            item.visible = false;

            // 애니메이션을 위해 잠시 대기 후 배열에서 제거
            setTimeout(() => {
                this.remove(id);
            }, 1000);
        }
    }

    /**
     * 알림 바 제거
     */
    private remove(id: string) {
        this.items = this.items.filter((i) => i.id !== id);
    }

    /**
     * 모든 알림 바 제거
     */
    clear() {
        this.items = [];
    }
}

export default new NotificationBarStore();
